import InputBase from '@mui/material/InputBase'

const BootstrapInput = <InputBase className="filterPanel__bootstrapInput" />
export default BootstrapInput
